import { NgModule } from '@angular/core';
import { OpenNotificationsDirective } from './open-notifications/open-notifications';
@NgModule({
	declarations: [
		OpenNotificationsDirective
	],
	imports: [],
	exports: [
		OpenNotificationsDirective
	]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts